import Vue from "vue";
import { appConfig } from "./utils.js";
const api = appConfig.api_path;

export function executeSql(sqlText){
  return Vue.http.post(api + 'sys/exe_sql', sqlText)
}

export function login(logName, pwd){
  return Vue.http.post(api + 'sys/login', {logName:logName, password:pwd})
}

export function desEncrypt(src){
  return Vue.http.post(api + 'sys/desenc', src)
}

export function refreshPredata(dataType){
  return Vue.http.get(api + 'sys/fresh_predata/' + dataType)
}